import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isNumber } from "util";
import { changeCartQuantity, confirmCartItems } from "../../store/cart";
import debounce from "lodash/debounce";
import shop from "../../api/shop";
import { getTranslate } from "react-localize-redux";
import { Input, InputGroup, InputGroupText, Button } from "reactstrap";
import { getCurrencySign } from "../../store/common";

class CartQuantityInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customPrice: this.props.cartProduct.price
    };
  }

  render() {
    const {
      quantity,
      cartProduct,
      changeCartQuantity,
      saveCartQuantity,
      customer,
      actionBar,
      translate,
      currencySign
    } = this.props;
    const {
      customPrice } = this.state;

    return (

      <React.Fragment >


        <InputGroup size="sm" className="group-quantity">
          <Input
            type="number"
            min="1"
            value={quantity}
            onChange={e => {
              changeCartQuantity(e.target.value, cartProduct, customPrice);
              saveCartQuantity(customPrice, cartProduct, customer, actionBar);
              e.stopPropagation();
            }}
            //className="cartBar__item__body__quantity"
            placeholder={translate(
              "molecules.containers.cartQuantityInput.quantiy_shorcode"
            )}
            aria-label="Quantity Component"
          />
          <InputGroupText className="btn-input-group">
            {translate(
              "molecules.containers.cartQuantityInput.quantiy_shorcode"
            )}
          </InputGroupText>
        </InputGroup>



        <InputGroup size="sm" className="group-quantity">
          <Input
            type='number'
            step='0.01'
            placeholder={cartProduct.minPrice}
            //className='productBox__body__price__input'
            onChange={e => this.setState({ customPrice: e.target.value })}
            value={customPrice}
            min={0.50}
            invalid={cartProduct.specialMinPrice > customPrice}
          />

          <InputGroupText className="btn-input-group">
            {currencySign}
          </InputGroupText>

        </InputGroup>

        <InputGroup className="group-quantity">
          <Button color={cartProduct.specialMinPrice > customPrice ? "danger" : "success"} disabled={cartProduct.specialMinPrice > customPrice} className="btn-input-group full-width" onClick={() => {
            if (cartProduct.specialMinPrice <= customPrice) {
              changeCartQuantity(cartProduct.quantity, cartProduct, customPrice);
              saveCartQuantity(customPrice, cartProduct, customer, actionBar);
            }
          }}><i class="fa fa-check-square-o"></i></Button>


        </InputGroup>



      </React.Fragment>
    )
  }
}

CartQuantityInput.propTypes = {
  quantity: PropTypes.number.isRequired,
  cartProduct: PropTypes.array,
  changeCartQuantity: PropTypes.func,
  saveCartQuantity: PropTypes.func,
  customer: PropTypes.array,
  actionBar: PropTypes.string,
  currencySign: PropTypes.string,
  translate: PropTypes.func
};

const mapStateToProps = ({ common, locale, customer }) => ({
  translate: getTranslate(locale),
  customer: common.user.personal.id,
  actionBar: customer.actionOnCustomer,
  currencySign: getCurrencySign(common.user.currency.sign),
});

const mapDispatchToProps = dispatch => ({
  changeCartQuantity: (val, cartProduct, ozPrice) => {
    if (isNumber(parseInt(val))) {
      cartProduct.quantity = parseInt(val);
      cartProduct.ozPrice = ozPrice.toString();
      dispatch(changeCartQuantity(cartProduct));
    }
  },
  saveCartQuantity: debounce((val, cartProduct, customer, actionBar) => {

    dispatch(
      confirmCartItems(
        cartProduct.id,
        customer,
        val.toString(),
        actionBar
      )
    );
  }, 500)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartQuantityInput);



// WEBPACK FOOTER //
// ./src/molecules/containers/CartQuantityPriceInput.js